import MeaButton from "../../../../components/MeaButton";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import studentsAPI from "../../../../services/students";
import { useRef } from "react";
import { Toast } from "primereact/toast";
import UpdateRegistrationLevelModal from "../modals/UpdateRegistrationLevelModal";
import UpdateRegistrationClasseModal from "../modals/UpdateRegistrationClasseModal";
import { Card } from "primereact/card";
import { PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import MeaStudentPreviousResult from "../../components/MeaStudentPreviousResult";
import UpdateRegistrationPreviousResultModal from "../modals/UpdateRegistrationPreviousResultModal";
import MeaLink from "../../../../components/MeaLink";
import UpdateStudentAffectationModal from "../../../trainings/students/components/UpdateStudentAffectationModal";
import RegistrationStepActions from "./RegistrationStepActions";

const RegistrationStepPreRegistrationComponent = ({ currentStudent, setCurrentStudent, callback, schoolId, trainingId }) => {

    const { hasPermission } = useAuthContext();
    const accessToken = "";

    const hasUpdateRegistrationsStatusPermission = hasPermission(PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS)

    const toast = useRef(null);

    const updateRegistrationPreviousResultModalRef = useRef(null);
    const updateStudentAffectationModalRef = useRef(null);
    const updateRegistrationLevelModalRef = useRef(null);
    const updateRegistrationClasseModalRef = useRef(null);
    const statusActionsRef = useRef(null);


    const updatePreviousTrainingInfos = async () => {
        studentsAPI.UpdatePreviousTrainingInfos(schoolId, trainingId, accessToken, currentStudent?.id)
            .then((data) => {

                toast.current.clear();
                toast.current.show({
                    severity: "success",
                    summary: "Succès",
                    detail: "Informations de la dernière inscription mis à jour!",
                    life: 3000,
                });
                callback?.();
            }
            )
            .catch((error) => {
                toast.current?.show({ severity: "error", summary: "Erreur", detail: error.message });
            }
            );
    };

    const headerTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <i className="text-2xl pi pi-th-large text-info"></i>
                    <span className="font-bold">Pré-inscription</span>
                </div>
                <div>
                    {options.togglerElement}
                </div>
            </div>
        );
    };

    const footerTemplate = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between`;
        return (<>
            {(currentStudent?.status === "PREREGISTRED") &&
                <div className={className}>
                    <div className="flex align-items-center gap-2">
                    </div>
                    <RegistrationStepActions
                        ref={statusActionsRef}
                        currentStudent={currentStudent}
                        schoolId={schoolId}
                        trainingId={trainingId}
                        callback={callback}
                        primary={{
                            label: "Confirmer l'inscription",
                            icon: "pi pi-check",
                            severity: "info",
                            disabled: !hasUpdateRegistrationsStatusPermission,
                            onClick: () => statusActionsRef.current?.changeStatus("ENROLLED"),
                        }}
                        items={[
                            {
                                label: "Annuler la pré-inscription",
                                icon: "pi pi-refresh",
                                visible: hasUpdateRegistrationsStatusPermission,
                                command: () => statusActionsRef.current?.changeStatus("NEW"),
                            },
                            {
                                label: "Mettre en liste d'attente",
                                icon: "pi pi-hourglass",
                                visible: hasUpdateRegistrationsStatusPermission,
                                command: () => statusActionsRef.current?.changeStatus("WAITING_LIST"),
                            },
                            {
                                label: "Désinscrire",
                                icon: "pi pi-sign-out",
                                visible: hasUpdateRegistrationsStatusPermission,
                                command: () => statusActionsRef.current?.changeStatus("UNREGISTRED"),
                            },
                        ]}
                    />
                </div>}
        </>);
    };

    return (
        <>
            <Toast ref={toast} position="top-right" />
            {(currentStudent?.status === "NEW" || currentStudent?.status === "PREREGISTRED" || currentStudent?.status === "ENROLLED") &&
                <Card footer={footerTemplate} >
                    <ul className="list-none p-0 m-0 ">
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Dernier résultat</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-10">{<MeaStudentPreviousResult student={currentStudent} schoolId={schoolId} trainingId={trainingId} />}</div>
                                    <div className="w-2">
                                        <MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} icon="pi pi-refresh" className="mr-2" size="small" text onClick={updatePreviousTrainingInfos} />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Dernière observation</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-full">{currentStudent?.previous_result_observation || "-"}</div>
                                </div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Dernière inscription</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-full">{currentStudent?.previous_training && <MeaLink to={"/school/" + currentStudent?.previous_training?.school_id + "/admin/trainings/" + currentStudent?.previous_training?.id}>{currentStudent?.previous_training?.name}</MeaLink> || <span>{currentStudent?.previous_training_name || "-"}</span>}</div>
                                </div>
                            </div>
                        </li>

                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Dernier(e) niveau/classe</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-full">{currentStudent?.previous_level_name || "-"}  {currentStudent?.previous_class_name ? " / " + currentStudent?.previous_class_name : ""}</div>
                                </div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Nouvelle affectation</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-10">{currentStudent?.level?.name || "-"} {currentStudent?.classe?.name ? " / " + currentStudent?.classe?.name : ""}</div>
                                    <div className="w-2">
                                        <MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} icon="pi pi-pencil" className="mr-2" size="small" text onClick={() => {
                                            if (updateStudentAffectationModalRef.current) {
                                                updateStudentAffectationModalRef.current.show(currentStudent, () => {
                                                    callback?.();
                                                });
                                            }
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </Card>}
            <UpdateStudentAffectationModal
                ref={updateStudentAffectationModalRef}
                student={currentStudent}
                schoolId={schoolId}
                trainingId={trainingId}
            />
            <UpdateRegistrationPreviousResultModal ref={updateRegistrationPreviousResultModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
            <UpdateRegistrationLevelModal ref={updateRegistrationLevelModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
            <UpdateRegistrationClasseModal ref={updateRegistrationClasseModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
        </>
    );
}

export default RegistrationStepPreRegistrationComponent;